import React from 'react';

const universities = {
  A: [
    "Arizona State University",
    "Auburn University",
    "American University",
    "Appalachian State University",
    "Augusta University",
  ],
  B: [
    "Boston University",
    "Baylor University",
    "Brown University",
    "Brigham Young University",
    "Boise State University",
    "Ball State University",
    "Bentley University",
    "Bucknell University",
  ],
  C: [
    "California Institute of Technology (Caltech)",
    "Carnegie Mellon University",
    "Clemson University",
    "Columbia University",
    "Cornell University",
    "Creighton University",
    "Chapman University",
    "Colorado State University",
  ],
  D: [
    "Dartmouth College",
    "Drexel University",
    "Duke University",
    "DePaul University",
  ],
  E: [
    "Emory University",
    "East Carolina University",
    "Eastern Michigan University",
    "Elon University",
  ],
  F: [
    "Florida State University",
    "Fordham University",
    "Franklin & Marshall College",
    "Fresno State University",
  ],
  G: [
    "Georgetown University",
    "George Washington University",
    "Georgia Institute of Technology",
    "Grand Valley State University",
  ],
  H: [
    "Harvard University",
    "Howard University",
    "Hofstra University",
    "Houston Baptist University",
  ],
  I: [
    "Indiana University Bloomington",
    "Iowa State University",
    "Illinois Institute of Technology",
  ],
  J: [
    "James Madison University",
    "Johns Hopkins University",
  ],
  K: [
    "Kansas State University",
    "Kent State University",
  ],
  L: [
    "Louisiana State University",
    "Lehigh University",
    "Loyola University Chicago",
  ],
  M: [
    "Massachusetts Institute of Technology (MIT)",
    "Miami University",
    "Michigan State University",
    "Mississippi State University",
    "Montana State University",
  ],
  N: [
    "New York University (NYU)",
    "Northwestern University",
    "Northeastern University",
    "North Carolina State University",
    "Northern Arizona University",
  ],
  O: [
    "Ohio State University",
    "Oklahoma State University",
    "Oregon State University",
  ],
  P: [
    "Princeton University",
    "Pennsylvania State University (Penn State)",
    "Pepperdine University",
    "Purdue University",
    "Portland State University",
  ],
  R: [
    "Rice University",
    "Rutgers University",
    "Rochester Institute of Technology (RIT)",
  ],
  S: [
    "Stanford University",
    "Syracuse University",
    "San Diego State University",
    "San Jose State University",
    "Seton Hall University",
  ],
  T: [
    "Texas A&M University",
    "Temple University",
    "Tufts University",
    "Texas Tech University",
  ],
  U: [
    "University of Alabama",
    "University of Arizona",
    "University of California, Berkeley",
    "University of California, Los Angeles (UCLA)",
    "University of Chicago",
    "University of Colorado Boulder",
    "University of Florida",
    "University of Georgia",
    "University of Illinois Urbana-Champaign",
    "University of Iowa",
    "University of Kansas",
    "University of Kentucky",
    "University of Maryland",
    "University of Michigan",
    "University of Minnesota",
    "University of North Carolina at Chapel Hill",
    "University of Notre Dame",
    "University of Oregon",
    "University of Pennsylvania",
    "University of Pittsburgh",
    "University of Southern California (USC)",
    "University of Texas at Austin",
    "University of Virginia",
    "University of Washington",
    "University of Wisconsin–Madison",
    "Utah State University",
  ],
  V: [
    "Vanderbilt University",
    "Virginia Tech",
    "Villanova University",
  ],
  W: [
    "Wake Forest University",
    "Washington State University",
    "Washington University in St. Louis",
    "West Virginia University",
    "Wichita State University",
    "Williams College",
    "Worcester Polytechnic Institute (WPI)",
  ],
  Y: [
    "Yale University",
    "Youngstown State University",
  ],
};

const USUniversities = () => {
  return (
    <div className="uk-container">
      <h2 className="uk-title">US Universities</h2>
      <table className="uk-table">
        <thead>
          <tr>
            <th>Letter</th>
            <th>University Name</th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(universities).map(([letter, uniList]) =>
            uniList.map((uni, idx) => (
              <tr key={`${letter}-${idx}`}>
                <td>{idx === 0 ? letter : ''}</td>
                <td>{uni}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default USUniversities;
